import { resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-b33b3ee4")

_pushScopeId("data-v-b33b3ee4")
const _hoisted_1 = { class: "button-content ellipsis-3-lines" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_q_icon = _resolveComponent("q-icon")
  const _component_q_btn = _resolveComponent("q-btn")

  return (_openBlock(), _createBlock(_component_q_btn, {
    class: ["button h-radius", { '--is-widget': _ctx.isWidget }],
    color: "primary",
    "text-color": "white",
    padding: "0 12px",
    disable: _ctx.disabled,
    onClick: _ctx.clickOnButton
  }, {
    default: _withId(() => [
      _createVNode("span", _hoisted_1, [
        _withDirectives(_createVNode(_component_q_icon, {
          name: _ctx.leftIcon,
          class: "q-mr-sm"
        }, null, 8, ["name"]), [
          [_vShow, _ctx.leftIcon]
        ]),
        _createVNode("div", {
          textContent: _toDisplayString(_ctx.button.text)
        }, null, 8, ["textContent"])
      ])
    ]),
    _: 1
  }, 8, ["class", "disable", "onClick"]))
})